//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: { type: Boolean, default: false },
    aliases: { type: Array, default: () => [] },
  },

  computed: {
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    searchAlias(alias) {
      this.$emit('searchAlias', alias);
    },
  },
};
